import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { useMusicVideoEditor } from '../MusicVideoEditorContext';
import { editorMessages } from '../messages/editorMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the editor; each part uses its own slice of it */
import styles from '../MusicVideoEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** Undo and Redo of the top bar (design b1). The keys are in `useEditorKeys`. */
const UndoRedoComponent: React.FC = () => {
  const intl = useIntl();
  const { dispatch, canUndo, canRedo, readOnly } = useMusicVideoEditor();
  return (
    <>
      <button
        type="button"
        className={styles.topButton}
        aria-label={intl.formatMessage(editorMessages.undo)}
        title={intl.formatMessage(editorMessages.undo)}
        disabled={!canUndo || readOnly}
        onClick={() => dispatch({ type: 'undo' })}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={1.8}
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden
        >
          <path d="M9 14L4 9l5-5" />
          <path d="M4 9h10a6 6 0 0 1 0 12h-3" />
        </svg>
      </button>
      <button
        type="button"
        className={styles.topButton}
        aria-label={intl.formatMessage(editorMessages.redo)}
        title={intl.formatMessage(editorMessages.redo)}
        disabled={!canRedo || readOnly}
        onClick={() => dispatch({ type: 'redo' })}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={1.8}
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden
        >
          <path d="M15 14l5-5-5-5" />
          <path d="M20 9H10a6 6 0 0 0 0 12h3" />
        </svg>
      </button>
    </>
  );
};

export const UndoRedo = TypedMemo(UndoRedoComponent);
